export default "__VITE_ASSET__ClBAbwPS__"